// extracted by mini-css-extract-plugin
export default {"icon":"legislation_parts-module__icon--13sth","container":"legislation_parts-module__container--dEtwh"};